// @ts-nocheck
import { Dialog, Button } from '@workspace/design-system/src/components';

interface ApplyPlanNoCustomerDialogProps {
  onClose: () => void;
  onConfirm: () => void;
}

export function ApplyPlanNoCustomerDialog({ onClose, onConfirm }: ApplyPlanNoCustomerDialogProps) {
  return (
    <Dialog>
      <Dialog.Content>
        <Dialog.Header title="고객 정보를 먼저 입력해 주세요" type="question" showIcon />

        <Dialog.Body>
          <p className="text-[14px] text-[#595959] leading-[20px] tracking-[-0.1px]">
            요금제 적용을 위해 고객 정보를 입력해 주세요.
          </p>
        </Dialog.Body>

        <Dialog.Footer>
          <Button
            type="button"
            onClick={onClose}
          >
            취소
          </Button>
          <Button
            type="button"
            styleType="primary"
            onClick={onConfirm}
          >
            고객 정보 입력
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}

